<template>
	<div class="jctp">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="jctpc">
					<div class="jct-head">
						<div class="jcth-item t1">议题名称</div>
						<div class="jcth-item t2">决策分类</div>
						<div class="jcth-item t3">状态</div>
						<div class="jcth-item t4">操作</div>
					</div>
					<div class="jct-body">
						<div class="jctb-row" v-for="(item, index) in jcList" :key="index">
							<div class="jctb-item t1">
								{{ item.decisionName | ellipisdata }}
							</div>
							<div class="jctb-item t2">{{ item.decisionCategory }}</div>
							<div class="jctb-item t3" v-if="item.status == '未开始'">
								{{ item.status }}
							</div>
							<div class="jctb-item t3" style="color:#16cc27" v-else-if="item.status == '进行中'">
								{{ item.status }}
							</div>
							<div class="jctb-item t3" style="color:#d31010" v-else>{{ item.status }}</div>
							<div class="jctb-item t4" @click="handleClick(item.id)">详情</div>
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				jcList: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
			};
		},
		mounted() {},
		filters: {
			ellipisdata: function(str) {
				if (str.length > 6) {
					return str.substring(0, 6) + "..."
				} else {
					return str
				}
			}
		},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					this.pageNum = 0;
					// 清空列表数据
					this.jcList = [];
					this.refreshing = false;
				}
				this.$axios.get('/api/v1/wechat/yzjc', {
					params: {
						pageNum: this.pageNum,
						pageSize: 15
					}
				}).then(res => {
					this.jcList.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.jcList.length >= res.total) {
						this.finished = true;
					}
				});
			},
			handleClick(id, status) {
				this.$router.push({
					path: "/yzjc/jcdet",
					query: {
						id: id
					}
				});
			}
		},
	};
</script>
<style lang="less" scoped="scoped">
	.jctp {
		width: 100%;

		.jctpc {
			margin: 10px;
			background-color: #ffffff;
			box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
			border-radius: 5px;

			.jct-head {
				width: 98%;
				height: 32px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #f4f4f4;
				margin: 0 auto;

				.jcth-item {
					width: 25%;
					height: 32px;
					text-align: center;
					line-height: 32px;
					color: #2a2a2a;
					font-size: 15px;
				}

				.t1 {
					width: 30%;
				}

				.t2 {
					width: 34%;
				}

				.t3 {
					width: 18%;
				}

				.t4 {
					width: 18%;
				}
			}

			.jct-body {
				width: 98%;
				//   height: 32px;
				margin: 0 auto;

				.jctb-row {
					width: 100%;
					height: 32px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid #f4f4f4;

					.jctb-item {
						height: 32px;
						text-align: center;
						line-height: 32px;
						color: #777777;
						font-size: 13px;
					}

					.t1 {
						width: 30%;
					}

					.t2 {
						width: 34%;
					}

					.t3 {
						width: 18%;
					}

					.t4 {
						width: 18%;
						color: #40b2ed;
					}
				}
			}
		}

	}
</style>
